import React from 'react';
import { Icon } from '@gerdau/hefesto';
import {
  CategoryContainer,
  CategoryItem,
  CategorySubtitle,
  CategoryText,
  CategoryTitle
} from './styles';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../routes';
import { EHelpCenterRoutes } from '..';
import { GetFlag } from '../../../utils/featureFlag';

const OTHERS_CATEGORY_TITLE = 'Outros';

export const HelpCenterContent = () => {
  const history = useHistory();

  const isNewApiEnabled = GetFlag('help_center_new_api');

  const FAQ = useSelector((state: ApplicationState) => state.helpCenter.faq);
  const commerceCategories = useSelector(
    (state: ApplicationState) => state.helpCenter.commerce.categories
  );

  const handleSelect = (categoryId: string) => {
    history.push(
      `${ERoutes.HELP_CENTER}${EHelpCenterRoutes.CATEGORY}/${categoryId}`
    );
  };

  if (isNewApiEnabled) {
    const categories = commerceCategories
      .filter((item) => item.is_active)
      .sort((a, b) => {
        if (a.name === OTHERS_CATEGORY_TITLE) return 1;
        if (b.name === OTHERS_CATEGORY_TITLE) return -1;
        return a.sort_order - b.sort_order || a.name.localeCompare(b.name);
      });

    return (
      <CategoryContainer>
        {categories.map((item) => (
          <CategoryItem
            key={item.category_id}
            onClick={() => handleSelect(String(item.category_id))}
          >
            <CategoryText>
              <CategoryTitle>{item.name}</CategoryTitle>
              <CategorySubtitle>{item.description}</CategorySubtitle>
            </CategoryText>
            <Icon option="ChevronRight" size="sm" variant="primary" />
          </CategoryItem>
        ))}
      </CategoryContainer>
    );
  }

  return (
    <CategoryContainer>
      {FAQ.categories
        ?.sort((a, b) => {
          if (a.title === 'Outros') return 1;
          if (b.title === 'Outros') return -1;
          return a.title.localeCompare(b.title);
        })
        ?.map((item) => (
          <CategoryItem key={item.id} onClick={() => handleSelect(item.id)}>
            <CategoryText>
              <CategoryTitle>{item.title}</CategoryTitle>
              <CategorySubtitle>{item.description}</CategorySubtitle>
            </CategoryText>
            <Icon option="ChevronRight" size="sm" variant="primary" />
          </CategoryItem>
        ))}
    </CategoryContainer>
  );
};
